<h3 class="text-lg ml-2 mr-2">Legierung auswählen</h3>
<p class="color-light ml-2 mr-2">Bitte wählen Sie die gewünschte Legierung durch tippen aus.</p>

<ul>
  @for (legierung of legierungen; track legierung; let last = $last) {
    <li class="list-item" (click)="close(legierung)" [ngClass]="last ? '' : 'border-b'">
      <span class="soft-text">{{ legierung.legierung }}</span>
      @if (legierung?.bezeichnung) {
        <span class="text-sm color-light">{{ legierung.bezeichnung }}</span>
      }
    </li>
  }
</ul>

<button class="soft-button secondary custom mt-3" (click)="close(null)">Abbrechen</button>
